module.exports = __webpack_public_path__ + "img/thomas_seeger.bf9c55e.jpg";